import React, { useMemo } from 'react';
import { formatMalls } from '../../../utils/formatForTables';
import AdminApi from '../../../../../services/Axios/AdminApi';

function useMallTable() {
  const [mallsData, setMallsData] = React.useState([]);
  const [searchText, setSearchText] = React.useState('');
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [pagination, setPagination] = React.useState({
    page: 1,
    total: 10,
  });

  React.useEffect(() => {
    AdminApi.getMalls({ page: pagination.page }).then((res) => {
      setPagination((p) => {
        if (p.page === res.page) {
          setMallsData(res?.data || []);
          return { page: res.page, total: res.total };
        }
        return p;
      });
    });
  }, [pagination.page]);

  const onMallsCreated = () => {
    setPagination((p) => ({
      ...p,
      total: p.total + 1,
      page: p.total && p.total % 10 === 0 ? p.page + 1 : p.page,
    }));
    if (pagination.total === 0 || pagination.total % 10 !== 0)
      AdminApi.getMalls({ page: pagination.page }).then((res) => {
        setMallsData(res?.data || []);
        setPagination({ page: res.page, total: res.total });
      });
  };

  const onPageChange = (page) => {
    setPagination((p) => ({ ...p, page }));
  };

  const onSearchChange = (text) => {
    setPagination({
      page: 1,
      total: 10,
    });
    setSearchText(text);
  };

  const fortmatedMalls = useMemo(
    () => formatMalls(mallsData, searchText, pagination.page),
    [mallsData, searchText],
  );

  return {
    malls: fortmatedMalls,
    searchText,
    isModalVisible,
    setIsModalVisible,
    pagination,
    setSearchText: onSearchChange,
    onPageChange,
    onMallsCreated,
  };
}

export default useMallTable;
